import { cn } from "@/lib/utils";

/** Three bouncing bars: "this is the one playing". Compositor-only. */
export function PlayingBars({
  className,
  barClassName,
}: {
  className?: string;
  barClassName?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn("flex h-3.5 items-end gap-[2px]", className)}
    >
      {[0, 0.25, 0.5].map((delay) => (
        <span
          key={delay}
          className={cn(
            "animate-music-bar block h-full w-[3px] rounded-full bg-current",
            barClassName,
          )}
          style={{ animationDelay: `${-delay}s` }}
        />
      ))}
    </span>
  );
}
